import { type PropsWithChildren } from 'react';
import { imageGetters } from '../../helpers/imageGetters';
import styles from './NativeMockBackground.module.css';

interface NativeMockBackgroundProps extends PropsWithChildren {}

export function NativeMockBackground(props: NativeMockBackgroundProps) {
  const { children } = props;

  return (
    <div className={styles.root}>
      <img className={styles.glowPink} src={imageGetters.glow('pink')} alt="" />
      <img className={styles.glowBlue} src={imageGetters.glow('blue')} alt="" />
      {children}
    </div>
  );
}
